import { EmptyState } from '@app/components/base/EmptyState';
import SensorsOffIcon from '@mui/icons-material/SensorsOff';
import { defineMessage, FormattedMessage } from 'react-intl';

const noSegmentsMessage = defineMessage({
  id: 'segments.listScreen.noSegments',
  defaultMessage: 'Sin emisión',
});

const noSegmentsHelpMessage = defineMessage({
  id: 'segments.listScreen.noSegments.help',
  defaultMessage: 'Pruebe cambiando el rango de tiempo seleccionado.',
});

/**
 * Component that displays a message when no segments are found.
 * Used to indicate an empty state in the stream content view.
 */
export function NoSegmentsMessage() {
  return (
    <EmptyState
      icon={SensorsOffIcon}
      message={<FormattedMessage {...noSegmentsMessage} />}
      help={<FormattedMessage {...noSegmentsHelpMessage} />}
    />
  );
}
